import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export default function ViewUnitVideos() {
  const { unit } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [statusMessage, setStatusMessage] = useState(null);
  const [savingVideoId, setSavingVideoId] = useState(null);

  // Video data for all units
  const allVideosData = {
    1: [
      { id: 1, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/10r2MP0lI0C09_rdYWMJSP-NzRt7wLbZK/view?usp=sharing', status: 'released' },
      { id: 2, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1NUEK4_wOosCCY1_-ccv5tOXVeZozvEWS/view?usp=sharing', status: 'released' },
      { id: 3, title: 'Episode 3', duration: '0 mins', url: 'https://drive.google.com/file/d/1E0ub8Jvxj-FlEEhwxJs-VxUybg5RfPA8/view?usp=sharing', status: 'released' },
      { id: 4, title: 'Episode 4', duration: '0 mins', url: 'https://drive.google.com/file/d/19Vk0Q0MfToon9F2VAbLZqUw5bGOSpMTD/view?usp=sharing', status: 'released' },
      { id: 5, title: 'Episode 5', duration: '0 mins', url: 'https://drive.google.com/file/d/16TXiD2HbeEN28kn_SRVG-Z_g-H6EOD2T/view?usp=sharing', status: 'released' },
      { id: 6, title: 'Episode 6', duration: '0 mins', url: 'https://drive.google.com/file/d/1id5Y_9AYermoHkcWLjlWDxEFHtR2Zabq/view?usp=sharing', status: 'released' },
      { id: 7, title: 'Episode 7', duration: '0 mins', url: 'https://drive.google.com/file/d/1xWrzO1IHnkeWhLdksz1b9n_5iSzhZ7Iq/view?usp=sharing', status: 'released' },
      { id: 8, title: 'Episode 8', duration: '0 mins', url: 'https://drive.google.com/file/d/1amh9u_vSXzdTdKUGGROOQPEjnDhhG_yN/view?usp=sharing', status: 'released' },
      { id: 9, title: 'Episode 9', duration: '0 mins', url: 'https://drive.google.com/file/d/1jbP09CInTTPcwvvMW-P8r_Z8yrrA8jF5/view?usp=sharing', status: 'released' },
      { id: 10, title: 'Episode 10', duration: '0 mins', url: 'https://drive.google.com/file/d/1N_jPObBgFctcIYo_AcS1jD8ohG1-3Eid/view?usp=sharing', status: 'released' },
      { id: 11, title: 'Episode 11', duration: '0 mins', url: 'https://drive.google.com/file/d/1Iy5t4YG-BTm4WuE1gRkF-Fr2BjBdKvB_/view?usp=sharing', status: 'released' },
      { id: 12, title: 'Episode 12', duration: '0 mins', url: 'https://drive.google.com/file/d/1O7cBqpvC6VysZGxVRIMdp0JFoXILz8WJ/view?usp=sharing', status: 'released' },
      { id: 13, title: 'Episode 13', duration: '0 mins', url: 'https://drive.google.com/file/d/1JOtU5EDD3Jt7Ky93F5MVqOkJ7vQSytOn/view?usp=sharing', status: 'released' },
      { id: 14, title: 'Episode 14', duration: '0 mins', url: 'https://drive.google.com/file/d/1iHQIet_tWYOpEKxrB6vgnh482421YJa1/view?usp=sharing', status: 'released' },
    ],
    2: [
      { id: 15, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/1CB9K68hoEDeXBYnujKTF1nC5jr4ndSGt/view?usp=sharing', status: 'released' },
      { id: 16, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1M5iEyBzx445ZUgxbrzKB1ufgWbx6_hbJ/view?usp=sharing', status: 'released' },
      { id: 17, title: 'Episode 3', duration: '0 mins', url: 'https://drive.google.com/file/d/1WJHjK2FVPUNMRoo7Tu5AYxAAdsVtoG3c/view?usp=sharing', status: 'released' },
    ],
    3: [
      { id: 18, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/1NsMEasa0rgpIn4DZR4MHxwIDrHMjsJII/view?usp=sharing', status: 'released' },
      { id: 19, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1Ou2P1MkCmhdKr3Rw2C2WQNB02iBsFTuW/view?usp=sharing', status: 'released' },
    ],
    4: [
      { id: 20, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/1cNVt5BzcUDMhVkOBqcbcI79NBr84HZqy/view?usp=sharing', status: 'released' },
      { id: 21, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1DjSGss47ugUFuS403KiPsuOYrIg5oteb/view?usp=sharing', status: 'released' },
    ],
  };

  const [videos, setVideos] = useState(allVideosData[unit] || []);

  // Load saved statuses from Firebase
  useEffect(() => {
    const loadVideoStatuses = async () => {
      if (!user || !user.id) return;
      
      try {
        const statusRef = doc(db, 'instructors', user.id, 'videoStatuses', 'statuses');
        const statusDoc = await getDoc(statusRef);
        
        if (statusDoc.exists()) {
          const savedStatuses = statusDoc.data();
          setVideos(prevVideos => 
            prevVideos.map(video => ({
              ...video,
              status: savedStatuses[`video_${video.id}`] || video.status
            }))
          );
        }
      } catch (error) {
        console.error('Error loading video statuses from Firestore:', error);
      }
    };
    
    loadVideoStatuses();
  }, [user]);

  // Toggle and save status
  const toggleVideoStatus = async (id) => {
    setSavingVideoId(id);
    const updatedVideos = videos.map(v => 
      v.id === id ? { ...v, status: v.status === 'released' ? 'closed' : 'released' } : v
    );
    setVideos(updatedVideos);
    const video = updatedVideos.find(v => v.id === id);

    if (user && user.id) {
      try {
        // Ensure parent instructor document exists
        const instructorRef = doc(db, 'instructors', user.id);
        await setDoc(instructorRef, { 
          createdAt: new Date().toISOString(), 
          updatedAt: new Date().toISOString() 
        }, { merge: true });
        
        const statusRef = doc(db, 'instructors', user.id, 'videoStatuses', 'statuses');
        
        // Get existing statuses first
        const statusDoc = await getDoc(statusRef);
        const existingStatuses = statusDoc.exists() ? statusDoc.data() : {};
        
        const updateData = {
          ...existingStatuses,
          [`video_${id}`]: video.status,
          lastUpdated: new Date().toISOString()
        };
        
        // Update with new status
        await setDoc(statusRef, updateData);
        
        setStatusMessage({
          type: 'success',
          title: `Video ${video.status === 'released' ? 'Released' : 'Closed'}`,
          message: `"${video.title}" is now ${video.status}`
        });
        
      } catch (error) {
        setVideos(videos);
        setStatusMessage({
          type: 'error',
          title: 'Save Failed',
          message: error.message || 'Could not save video status'
        });
      } finally {
        setSavingVideoId(null);
      }
    }
  };

  const deleteVideo = (id) => {
    setVideos(videos.filter(v => v.id !== id));
  };

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '3rem', display: 'flex', alignItems: 'center', gap: '1rem', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
          <button
            onClick={() => navigate('/manage-videos')}
            style={{
              background: '#1a1a1a',
              border: 'none',
              color: 'white',
              padding: '0.6rem 0.8rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1.1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 300ms ease'
            }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0' }}>
              <i className="fas fa-video" style={{ marginRight: '1rem', color: '#1a1a1a' }}></i>
              Unit {unit} Videos
            </h1>
            <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
              Manage videos for Unit {unit} - {videos.length} episodes
            </p>
          </div>
        </div>

        {/* Status Message */}
        {statusMessage && (
          <div style={{
            background: statusMessage.type === 'success' ? '#e8f5e9' : '#ffebee',
            border: `2px solid ${statusMessage.type === 'success' ? '#4caf50' : '#f44336'}`,
            color: statusMessage.type === 'success' ? '#2e7d32' : '#c62828',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <strong>{statusMessage.title}</strong><br/>
              {statusMessage.message}
            </div>
            <button
              onClick={() => setStatusMessage(null)}
              style={{ background: 'transparent', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'inherit' }}
            >
              ✕
            </button>
          </div>
        )}

        {/* Videos Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
          {videos.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '3rem', background: '#f9f9f9', borderRadius: '8px', border: '2px dashed #e8e8e8' }}>
              <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>No videos for this unit.</p>
            </div>
          ) : (
            videos.map(video => (
              <div 
                key={video.id}
                style={{
                  background: '#fff',
                  border: '1px solid #e8e8e8',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  transition: 'all 300ms ease',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div 
                  style={{ 
                    background: '#1a1a1a', 
                    color: '#fff', 
                    padding: '1.5rem', 
                    minHeight: '100px', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                  onClick={() => window.open(video.url, '_blank')}
                >
                  <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700 }}>{video.title}</h3>
                  <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.95rem', opacity: 0.9 }}>
                    <i className="fas fa-clock" style={{ marginRight: '0.5rem' }}></i>
                    {video.duration}
                  </p>
                  <p style={{ margin: '0.75rem 0 0 0', fontSize: '0.85rem', opacity: 0.7 }}>
                    <i className="fas fa-external-link-alt" style={{ marginRight: '0.5rem' }}></i>
                    Click to open video
                  </p>
                </div>
                
                <div style={{ padding: '1.5rem' }}>
                  <div style={{ marginBottom: '1rem' }}>
                    <span style={{
                      display: 'inline-block',
                      background: video.status === 'released' ? '#e8f5e9' : '#ffebee',
                      color: video.status === 'released' ? '#2e7d32' : '#c62828',
                      padding: '0.5rem 1rem',
                      borderRadius: '20px',
                      fontSize: '0.85rem',
                      fontWeight: 600
                    }}>
                      {video.status === 'released' ? '● Released' : '● Closed'}
                    </span>
                  </div>
                  
                  <div style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid #e8e8e8' }}>
                    <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', wordBreak: 'break-all' }}>
                      <strong>URL:</strong><br/>
                      <a href={video.url} target="_blank" rel="noopener noreferrer" style={{ color: '#1a1a1a', textDecoration: 'none', fontWeight: 500 }}>
                        {video.url.substring(0, 50)}...
                      </a>
                    </p>
                  </div>
                  
                  <div style={{ display: 'flex', gap: '0.75rem' }}>
                    <button 
                      onClick={() => toggleVideoStatus(video.id)}
                      disabled={savingVideoId === video.id}
                      style={{
                        flex: 1,
                        background: video.status === 'released' ? '#e8e8e8' : '#1a1a1a',
                        color: video.status === 'released' ? '#1a1a1a' : '#fff',
                        border: 'none',
                        padding: '0.6rem',
                        borderRadius: '6px',
                        fontWeight: 600,
                        cursor: savingVideoId === video.id ? 'wait' : 'pointer',
                        fontSize: '0.9rem',
                        transition: 'all 300ms ease',
                        opacity: savingVideoId === video.id ? 0.6 : 1
                      }}
                      onMouseOver={(e) => !savingVideoId && (e.target.style.opacity = '0.8')}
                      onMouseOut={(e) => !savingVideoId && (e.target.style.opacity = '1')}
                    >
                      {savingVideoId === video.id ? 'Saving...' : (video.status === 'released' ? 'Close' : 'Release')}
                    </button>
                    <button 
                      onClick={() => deleteVideo(video.id)}
                      style={{
                        flex: 1,
                        background: '#ffebee',
                        color: '#c62828',
                        border: '1px solid #ffcdd2',
                        padding: '0.6rem',
                        borderRadius: '6px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        transition: 'all 300ms ease'
                      }}
                      onMouseOver={(e) => e.target.style.opacity = '0.8'}
                      onMouseOut={(e) => e.target.style.opacity = '1'}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
